export default __webpack_public_path__ + "static/media/iconmonstr-pencil-16.3bc63c83.svg";